import { AnyAction } from 'redux';

import { AnalyticsQueryParams } from '@candu-ai/analytics/types';

import {
  RESET_SEARCH_STATE,
  SET_DATE_RANGE,
  SET_EDITING_FILTER,
  SET_FILTERS,
  SET_SHORT_TIME_INTERVAL,
  SET_WHITELISTED_SEGMENT_IDS,
  TOGGLE_IS_ADDING_FILTER,
} from './constants';

import { decodeFilters } from '../filtersMarshalling';
import { Filter } from '../types';

export type AnalyticsSearchState = {
  isAddingFilter: boolean;
  editingFilter?: Filter;
  filters: Filter[];
  shortTimeInterval: string;
  whitelistedSegmentIds: string[];
  dateRange: [Date | undefined, Date | undefined];
};

const readDate = (t: any) => {
  try {
    return new Date(parseInt(t, 10) * 1000);
  } catch (e) {
    return undefined;
  }
};

const getInitialState = (): AnalyticsSearchState => {
  const searchParams = new URLSearchParams(window.location.search);

  const shortIntervalOverride = searchParams.has(AnalyticsQueryParams.Timestamp)
    ? { shortTimeInterval: 'custom' }
    : {};

  return {
    isAddingFilter: false,
    editingFilter: undefined,
    whitelistedSegmentIds: [],
    filters: decodeFilters(searchParams.get(AnalyticsQueryParams.Filters) || ''),
    shortTimeInterval: searchParams.get(AnalyticsQueryParams.TimeInterval) || '7d',
    ...shortIntervalOverride,

    dateRange: [
      readDate(searchParams.get(AnalyticsQueryParams.Timestamp)),
      readDate(searchParams.get(AnalyticsQueryParams.UpperTimestamp)),
    ],
  };
};

export const searchReducer = (state = getInitialState(), action: AnyAction) => {
  switch (action.type) {
    case RESET_SEARCH_STATE:
      return { ...state, ...getInitialState() };

    case SET_WHITELISTED_SEGMENT_IDS:
      return { ...state, whitelistedSegmentIds: action.whitelistedSegmentIds };

    case TOGGLE_IS_ADDING_FILTER:
      return {
        ...state,
        isAddingFilter: !state.isAddingFilter,
        editingFilter: !state.isAddingFilter ? undefined : state.editingFilter,
      };

    case SET_EDITING_FILTER:
      return {
        ...state,
        editingFilter: action.editingFilter,
        isAddingFilter: action.editingFilter ? false : state.isAddingFilter,
      };

    case SET_FILTERS:
      return { ...state, filters: action.filters };

    case SET_SHORT_TIME_INTERVAL:
      return {
        ...state,
        shortTimeInterval: action.shortTimeInterval,
        ...(action.shortTimeInterval !== 'custom' ? { dateRange: [undefined, undefined] } : {}),
      };

    case SET_DATE_RANGE:
      return { ...state, dateRange: action.dateRange };

    default:
      return state;
  }
};
